import {
  normalizePayloadValue,
  UPLOAD_PROGRESS_MAX,
} from 'helpers/publishProgressUtils';
import {
  submitPublishRequest,
  uploadPublishImage,
  uploadPublishImageAsset,
} from 'helpers/publishJobUtils';

export const runPatchPublishJob = ({
  job,
  accessToken,
  onProgress,
  signal,
  createPath,
  updatePath,
  entityLabel,
  titleField,
}) =>
  submitPublishRequest({
    job,
    createPath,
    updatePath,
    payload: {
      ...job.payload,
      ...(titleField && job.payload?.[titleField] !== undefined
        ? {
            [titleField]: normalizePayloadValue(
              job.payload[titleField] ?? job.title,
            ),
          }
        : {}),
    },
    accessToken,
    signal,
    onProgress,
    entityLabel,
    uploadPercent: 0,
    updateMethod: 'PATCH',
  });

export const runSingleImagePatchPublishJob = async ({
  job,
  files,
  accessToken,
  onProgress,
  signal,
  createPath,
  updatePath,
  entityLabel,
  imageField = 'image',
  titleField,
  thumbnailRequired = 'No',
  updateMethod = 'PATCH',
  imageOptional = false,
}) => {
  const payload = { ...job.payload };
  const imageUrl = await uploadPublishImage({
    file: files?.imageFile,
    existingUrl: files?.existingImage || payload[imageField],
    accessToken,
    signal,
    onProgress,
    phase: 'uploading-image',
    rangeStart: 0,
    rangeEnd: UPLOAD_PROGRESS_MAX,
    thumbnailRequired,
  });

  if (!imageUrl) {
    if (!imageOptional) {
      throw new Error('Image is required.');
    }
    payload[imageField] = null;
  } else {
    payload[imageField] = imageUrl;
  }

  return submitPublishRequest({
    job,
    createPath,
    updatePath,
    payload: {
      ...payload,
      ...(titleField && payload[titleField] !== undefined
        ? {
            [titleField]: normalizePayloadValue(
              payload[titleField] ?? job.title,
            ),
          }
        : {}),
    },
    accessToken,
    signal,
    onProgress,
    entityLabel,
    uploadPercent: 0,
    updateMethod,
  });
};

export const runImageDtoPatchPublishJob = async ({
  job,
  files,
  accessToken,
  onProgress,
  signal,
  createPath,
  updatePath,
  entityLabel,
  titleField,
}) => {
  const payload = { ...job.payload };
  const existingImage = files?.existingImage || payload.image;

  const uploaded = await uploadPublishImageAsset({
    file: files?.imageFile,
    existingUrl: existingImage?.url,
    existingThumbnail: existingImage?.thumbnail,
    accessToken,
    signal,
    onProgress,
    phase: 'uploading-image',
    rangeStart: 0,
    rangeEnd: UPLOAD_PROGRESS_MAX,
    thumbnailRequired: 'Yes',
  });

  if (!uploaded?.url) {
    throw new Error('Image is required.');
  }

  payload.image = {
    url: uploaded.url,
    thumbnail: uploaded.thumbnail,
    imageTag: payload.image?.imageTag || existingImage?.imageTag || '',
  };

  return submitPublishRequest({
    job,
    createPath,
    updatePath,
    payload: {
      ...payload,
      ...(titleField && payload[titleField] !== undefined
        ? {
            [titleField]: normalizePayloadValue(
              payload[titleField] ?? job.title,
            ),
          }
        : {}),
    },
    accessToken,
    signal,
    onProgress,
    entityLabel,
    uploadPercent: 0,
    updateMethod: 'PATCH',
  });
};

export const hasSingleImageFiles = (job, files) =>
  Boolean(files?.imageFile || files?.existingImage);
